import { z } from "zod";

export const fileDownloadSchema = z.object({
  url: z.string(),
});

export type FileDownload = z.infer<typeof fileDownloadSchema>;